import { render, staticRenderFns } from "./NewRirekishoPreview.vue?vue&type=template&id=8e909248&"
import script from "./NewRirekishoPreview.vue?vue&type=script&lang=js&"
export * from "./NewRirekishoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports